module.exports = __webpack_public_path__ + "static/media/dialog-file.5cd14729.svg";